module.exports = __webpack_public_path__ + "static/media/sprite-v4.a24c2dfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sprite-v4.png
// module id = 105
// module chunks = 0